import { Dialog, Drawer } from '@elementary/common-ui/components';
import useSidePanelParams from '@elementary/common-ui/hooks/useSidePanelParams';
import { ReactComponent as TrashIcon } from '@elementary/common-ui/assets/trash.svg';
import Panel from './Panel';
import PanelHeader from './PanelHeader';

const SidePanel = () => {
  const {
    isOpen,
    closeSidePanel,
    onDiscardChanges,
    onCloseDiscardDialog,
    showDiscardDialog,
  } = useSidePanelParams();

  return (
    <>
      <Drawer
        isOpen={isOpen}
        onClose={closeSidePanel}
        title={<PanelHeader hideCloseButton />}
      >
        <Panel hideHeader />
      </Drawer>

      <Dialog
        open={!!showDiscardDialog}
        onClose={onCloseDiscardDialog}
        onConfirmButtonClick={onDiscardChanges}
        titleIcon={<TrashIcon />}
        title="You have unsaved configuration changes"
        message="Any unsaved changes will be discarded"
        confirmText="Discard"
      />
    </>
  );
};

export default SidePanel;
